import { useAppStore } from '@/features/shared/app-store';

export const init = () => useAppStore.getState().consentActions.init();
export const refresh = () => useAppStore.getState().consentActions.refresh();
export const toggleCookieBanner = () => useAppStore.getState().consentActions.toggleCookieBanner();
